import { render, staticRenderFns } from "./target.vue?vue&type=template&id=79ba8ab3&scoped=true"
import script from "./target.vue?vue&type=script&lang=js"
export * from "./target.vue?vue&type=script&lang=js"
import style0 from "./target.vue?vue&type=style&index=0&id=79ba8ab3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ba8ab3",
  null
  
)

export default component.exports